import { render, staticRenderFns } from "./App.vue?vue&type=template&id=089a4b45&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"
import style0 from "./App.vue?vue&type=style&index=0&id=089a4b45&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=089a4b45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089a4b45",
  null
  
)

export default component.exports